export const cashSans = {
  fontFamily: "Cash Sans",
  fontWeight: 400,
  src: `url(https://cash-f.squarecdn.com/static/fonts/cashsans/woff2/CashSans-Regular.woff2)
  format("woff");
  `,
};

export const cashSansMedium = {
  fontFamily: "Cash Sans",
  fontWeight: 600,
  src: `url(https://cash-f.squarecdn.com/static/fonts/cashsans/woff2/CashSans-Medium.woff2)
  format("woff");
  `,
};
